export default "/images/vendor/flag-icons/flags/4x3/hm.svg?7357662d39fe5b26e5f2ef5bf9d90928";